import { Fade, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import { EntityWindowWrapper } from 'src/pages/Conversations/shared-layout';

interface EntityPeekSlotProps {
  open: boolean;
  isMobile: boolean;
  children: ReactNode;
}

export const EntityPeekSlot = ({ open, isMobile, children }: EntityPeekSlotProps) => {
  const theme = useTheme();

  return (
    <Fade in={open}>
      <EntityWindowWrapper
        sx={
          isMobile
            ? { [theme.breakpoints.up('sm')]: { minWidth: '340px' } }
            : // desktop: the panel owns its width (see EntityDetachedPanel /
              // records-grid-layout.tsx panelOwnsWidth mode) — it must size to
              // its own content instead of stretching to fill the row
              { flex: '0 0 auto', minWidth: 0 }
        }
      >
        {children}
      </EntityWindowWrapper>
    </Fade>
  );
};
